/**
 * @module FonctionUtilitaire
 */
class FonctionUtilitaire {

  static readonly dateToJJMoisAAAA = (date: Date, langue: string) => {
    const jour = date.getDate();
    const mois = date.toLocaleString(langue, { month: 'long' });
    const annee = date.getFullYear();
    return jour + mois + annee;
  };

  static readonly dateToJJMois = (date: Date, langue: string) => {
    const optionsDate: Intl.DateTimeFormatOptions = { month: 'long', day: 'numeric'};
    let jjmois = date.toLocaleDateString(langue, optionsDate);
    if (langue === "en") {
      return `${jjmois},`;
    }
    if (langue === "fr") {
      if (date.getDate() === 1) {
        jjmois = jjmois.replace(/^1 /, "1<sup>er</sup> ");
      }
    }
    return `${jjmois}`;
  };

  static readonly dateToAAAA = (date: Date) => {
    const annee = date.getFullYear();
    return " " + annee;
  };
}

export default FonctionUtilitaire;
